@if (currentSelectedRecord()) {
    <div
        class="st-sidecar-full-screen-border-left"
        st-left-border
        [data]="currentSelectedRecord()"></div>
}
<div class="st-sidecar-full-screen-item">
    <mat-chip-listbox
        class="st-sidecar-full-screen-header"
        tabIndex="0"
        (change)="openSidecarMenu($event)">
        @if (isBackButtonShown()) {
            <button
                class="st-sidecar-full-screen-header--sidecar-button"
                mat-icon-button
                [matTooltip]="languageSettings.PSTWebBackButtonLabel"
                (click)="backToList()">
                <mat-icon>arrow_back</mat-icon>
            </button>
        }
        @for (menu of sidecarMenus$ | ngrxPush; track menu) {
            <mat-chip-option
                class="st-sidecar-full-screen-header--sidecar-option"
                [value]="menu"
                [selected]="selectedSidecarMenu() === menu">
                {{ languageSettings[sidecarMenuLabelsMap[menu]] }}
                @if (menu === SideCartMenu.ROVER_AI) {
                    @if (!environment.demoModeNotForProduction) {
                        <st-beta class="st-sidecar-full-screen-header--sidecar-beta" />
                    }
                }
            </mat-chip-option>
        }
    </mat-chip-listbox>
    <div class="st-sidecar-full-screen-content">
        @switch (selectedSidecarMenu()) {
            @case (SideCartMenu.ASSIGNMENTS) {
                <st-assignment-list-sidecar [sidecarMenu]="type()" />
            }
            @case (SideCartMenu.MOS) {
                <st-mos-full-screen [sidecarMenu]="type()" />
            }
            @case (SideCartMenu.RUNDOWNS) {
                <st-rundown-list-sidecar [sidecarMenu]="type()" />
            }
            @case (SideCartMenu.STORIES) {
                <st-stories-list-sidecar [sidecarMenu]="type()" />
            }
            @case (SideCartMenu.TOPICS) {
                <st-topic-list-sidecar [sidecarMenu]="type()" />
            }
            @case (SideCartMenu.ROVER_AI) {
                <st-rover-ai-full-screen [sidecarMenu]="type()" />
            }
            @case (SideCartMenu.DISCOVER_ITEMS) {
                <st-discover-wire-fullscreen [isInSidecar]="true" />
            }
            @case (SideCartMenu.NOTES) {
                <st-notes-list-sidecar [sidecarMenu]="type()" />
            }
        }
    </div>
</div>
